module.exports = __webpack_public_path__ + "fonts/c75e3d3ca80529c80636073b3f079b19.woff";